import React, { Component } from 'react';
import DateInput from '../DateInput'; // notre nouveau composant
import { fr } from 'date-fns/locale';
import { Link } from 'react-router-dom';
import { storeRapport } from '../../tools/fonctions';
import { isMobile } from 'react-device-detect';
import './css/Filtre.css';

class Filtre extends Component {
  state = {
    agences: [],
    secteurs: [],
    dateDeb: new Date(),
    dateFin: new Date(),
    nomSect: "",
    nomAg: ""
  };

  componentDidMount() {
    if (!window.localStorage.email) return;

    // Fetch agences
    fetch('https://us-central1-bi-secu.cloudfunctions.net/getListeAgences')
      .then(res => res.json())
      .then(data => this.setState({ agences: data }));

    // Fetch secteurs
    fetch('https://us-central1-bi-secu.cloudfunctions.net/getListeSecteurs')
      .then(res => res.json())
      .then(data => this.setState({ secteurs: data }));

    // Initialiser les filtres depuis localStorage
    this.setState({
      nomSect: window.localStorage.Secteur || "",
      nomAg: window.localStorage.Agence || ""
    });
  }

  handleClickReinit = (e) => {
    const id = e.target.id;

    switch (window.localStorage.Autorisation) {
      case 'National':
        this.setState({ [id]: '' });
        break;
      case 'Secteur':
        if (id !== 'nomSect') this.setState({ [id]: '' });
        break;
      default:
        break;
    }

    if (id === 'dateDeb') this.setState({ dateDeb: new Date() });
    if (id === 'dateFin') this.setState({ dateFin: new Date() });
  };

  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState({ [id]: value });

    if (id === 'nomSect') this.setState({ nomAg: '' });
  };

  render() {
    const { secteurs, agences, nomSect, nomAg, dateDeb, dateFin } = this.state;
    const { Autorisation, nomParamSecteur, nomParamAgence, dateParamDeb, dateParamFin } = window.localStorage;

    const sortedSecteurs = secteurs.sort((a, b) => a.nomSecteur.localeCompare(b.nomSecteur));
    const sortedAgences = agences.sort((a, b) => a.nomAgence.localeCompare(b.nomAgence));

    const optionSecteurDeroulant = sortedSecteurs
      .filter(s => s.isActif)
      .map((secteur, i) => <option key={i} value={secteur.nomSecteur}>{secteur.nomSecteur}</option>);

    const optionAgenceDeroulant = sortedAgences
      .filter(a => a.isActive && (!nomSect || a.idSecteur === secteurs.find(s => s.nomSecteur === nomSect)?.idSecteur))
      .map((agence, i) => <option key={i} value={agence.nomAgence.replace('Agence de ', '')}>{agence.nomAgence.replace('Agence de ', '')}</option>);

    return (
      <div className="container">
        <div className="filtre d-flex">
          <form className="d-inline-block mt-2">
            <div className={isMobile ? "col" : "row"}>

              {/* Sélecteur Secteur */}
              {nomParamSecteur && (
                <div className="form-group">
                  <div className="d-flex secteur ml-3" style={{ width: '170px' }}>
                    <select
                      onChange={this.handleChange}
                      value={nomSect}
                      id="nomSect"
                      className="custom-select"
                      disabled={Autorisation === "Secteur"}
                    >
                      <option value="">{secteurs.length ? 'Secteur' : 'Chargement des secteurs'}</option>
                      {optionSecteurDeroulant}
                    </select>
                    <button type="button" className="close" aria-label="Close" onClick={this.handleClickReinit}>
                      <span id="nomSect" aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Sélecteur Agence */}
              {nomParamAgence && (
                <div className="form-group">
                  <div className="d-flex agence ml-3" style={{ width: '170px' }}>
                    <select
                      onChange={this.handleChange}
                      value={nomAg}
                      id="nomAg"
                      className="custom-select"
                      disabled={Autorisation === "Agence"}
                    >
                      <option value="">{agences.length ? 'Agence' : 'Chargement des agences'}</option>
                      {optionAgenceDeroulant}
                    </select>
                    <button type="button" className="close" aria-label="Close" onClick={this.handleClickReinit}>
                      <span id="nomAg" aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Date début */}
              {dateParamDeb && (
                <div className="form-group ml-3">
                  <DateInput
                    selected={dateDeb}
                    onSelect={(day) => this.setState({ dateDeb: day })}
                    placeholder="Date de début"
                  />
                  <button type="button" className="close" aria-label="Close" onClick={this.handleClickReinit}>
                    <span id="dateDeb" aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}

              {/* Date fin */}
              {dateParamFin && (
                <div className="form-group ml-3">
                  <DateInput
                    selected={dateFin}
                    onSelect={(day) => this.setState({ dateFin: day })}
                    placeholder="Date de fin"
                  />
                  <button type="button" className="close" aria-label="Close" onClick={this.handleClickReinit}>
                    <span id="dateFin" aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}

              {/* Bouton Chercher */}
              {(nomParamSecteur || nomParamAgence || dateParamDeb || dateParamFin) ? (
                <div className="form-group ml-3">
                  <Link
                    to="/rapport"
                    onClick={() => storeRapport(null, null, null, nomSect, nomAg, dateDeb, dateFin)}
                    className="btn btn-primary"
                    style={{ width: '100px' }}
                  >
                    Chercher
                  </Link>
                </div>
              ) : (
                <div className="form-group">
                  <h5 className="mt-1">Aucun filtre</h5>
                </div>
              )}

            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Filtre;
